module.exports = __webpack_public_path__ + "static/media/cheveron-right.1d692f3d.svg";